import axios from 'axios'
import {accessToken, sessionAction, refreshAccess, clearLogin, rememberReturnPath, confirmContactAccess} from '../../../utility/adminSessionClient'
export const AuthConfig = {loginEndpoint:'/admin-session/login', registerEndpoint:'/jwt/register', refreshEndpoint:'/admin-session/refresh', logoutEndpoint:'/admin-session/logout', storageTokenKeyName:'accessToken', tokenType:'Bearer'}
class JwtService {
 authConfig = AuthConfig
 constructor() {
  axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL
  axios.interceptors.request.use(config => { const token = accessToken(); if (token) config.headers.Authorization = `Bearer ${token}`; return config })
  axios.interceptors.response.use(response => { if (response.data?.success === false && response.data?.error?.msg) window.alert(response.data.error.msg); return response.data }, async error => {
   const {config, response} = error
   if (response?.status === 401 && !config._adminRefreshed) {
    try { const r = await refreshAccess(); config._adminRefreshed = true; config.headers.Authorization = `Bearer ${r.accessToken}`; return axios(config) } catch (e) {
     if (e.response?.status === 401) { rememberReturnPath(); clearLogin(); window.location.assign('/moaland/auth/intro') }
     return Promise.reject(e)
    }
   }
   if (response?.status === 401) { rememberReturnPath(); clearLogin(); window.location.assign('/moaland/auth/intro'); return Promise.reject(error) }
   const code = response?.data?.error?.code
   if (response?.status === 423 && code === 'ADMIN_SCREEN_LOCKED') window.dispatchEvent(new Event('admin-screen-lock'))
   else if (response?.status === 403 && code === 'ADMIN_CONTACT_CONFIRM_REQUIRED') {
    if (config.method === 'get' && !config._adminContactConfirmed) {
     try { await confirmContactAccess(); config._adminContactConfirmed = true; return axios(config) } catch (e) { return Promise.reject(e) }
    }
   } else if (response?.status === 403 && code === 'PASSWORD_CHANGE_REQUIRED') window.location.assign('/moaland/auth/password')
   else if (response?.status === 403) window.alert(response.data?.error?.msg || '이 작업에 접근할 권한이 없습니다.')
   return Promise.reject(error)
  })
 }
 getToken() { return accessToken() }
 setToken(value) { sessionStorage.setItem('accessToken', value) }
 login(data) { return sessionAction('login', data) }
 register(...args) { return axios.post(this.authConfig.registerEndpoint, ...args) }
 refreshToken() { return refreshAccess() }
}
export default function useJwt() { return new JwtService() }
